export const HANDLE_WIDTH = 40 as const;
